import { MainContent } from "./style";
import { useContext } from "react";
import { UserContext } from "../../../providers/UserContext";
import { Product } from "./ProductCard";

export const Main = () => {
  const { products, filterProducts } = useContext(UserContext);
  return (
    <MainContent>
      <ul>
        {filterProducts.length ? (
          <>
            {filterProducts.map((product) => {
              return <Product key={product.id} product={product} />;
            })}
          </>
        ) : (
          <>
            {products.map((product) => {
              return <Product key={product.id} product={product} />;
            })}
          </>
        )}
      </ul>
    </MainContent>
  );
};
